<template>
    <Container>
        <div class="w-full flex my-4 gap-3">
            <Link
                href="/backstage/scholars/create"
                class="text-nomad-accent rounded-md py-2 px-3 bg-nomad-700 hover:bg-nomad-600"
                >Create</Link
            >
            <Link
                href="/backstage"
                class="text-white rounded-md py-2 px-3 bg-nomad-900 hover:bg-nomad-800"
                >Cancel</Link
            >
        </div>
        <div class="w-full">
            <ul v-if="scholars && scholars.data" class="grid gap-3">
                <li
                    v-for="scholar in scholars.data"
                    :key="scholar.id"
                    class="p-3 bg-nomad-900 rounded-3xl text-white"
                >
                    <Link :href="'/backstage/scholars/' + scholar.id + '/edit'">
                        <h2 class="text-xl text-nomad-200">
                            {{ scholar.name }}
                        </h2>
                        <span class="text-nomad-600 mr-2">{{ scholar.updated_at }}</span>
                    </Link>
                </li>
            </ul>
        </div>
    </Container>
</template>
<script setup>
import Container from "@/Pages/Backstage/Container.vue";
import { Link, usePage } from "@inertiajs/vue3";
const { scholars } = usePage().props;
</script>